// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"2ac1521a","948":"c9795a4b","965":"441b3198"}[chunkId] + ".chunk.css";
};